var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(WvwEndpoint, _AbstractEndpoint);

  function WvwEndpoint() {
    _classCallCheck(this, WvwEndpoint);

    return _possibleConstructorReturn(this, _getPrototypeOf(WvwEndpoint).apply(this, arguments));
  }

  _createClass(WvwEndpoint, [{
    key: "abilities",
    value: function abilities() {
      return new AbilitiesEndpoint(this);
    }
  }, {
    key: "matches",
    value: function matches() {
      return new MatchesEndpoint(this);
    }
  }, {
    key: "objectives",
    value: function objectives() {
      return new ObjectivesEndpoint(this);
    }
  }, {
    key: "upgrades",
    value: function upgrades() {
      return new UpgradesEndpoint(this);
    }
  }, {
    key: "ranks",
    value: function ranks() {
      return new RanksEndpoint(this);
    }
  }]);

  return WvwEndpoint;
}(AbstractEndpoint);

var AbilitiesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(AbilitiesEndpoint, _AbstractEndpoint2);

  function AbilitiesEndpoint(client) {
    var _this;

    _classCallCheck(this, AbilitiesEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbilitiesEndpoint).call(this, client));
    _this.url = '/v2/wvw/abilities';
    _this.isPaginated = true;
    _this.isBulk = true;
    _this.isLocalized = true;
    _this.cacheTime = 24 * 60 * 60;
    return _this;
  }

  return AbilitiesEndpoint;
}(AbstractEndpoint);

var MatchesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(MatchesEndpoint, _AbstractEndpoint3);

  function MatchesEndpoint(client) {
    var _this2;

    _classCallCheck(this, MatchesEndpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MatchesEndpoint).call(this, client));
    _this2.url = '/v2/wvw/matches';
    _this2.isPaginated = true;
    _this2.isBulk = true;
    _this2.cacheTime = 30;
    return _this2;
  }

  _createClass(MatchesEndpoint, [{
    key: "world",
    value: function world(worldId) {
      return _get(_getPrototypeOf(MatchesEndpoint.prototype), "get", this).call(this, "?world=".concat(worldId), true);
    }
  }, {
    key: "overview",
    value: function overview() {
      return new MatchesOverviewEndpoint(this);
    }
  }, {
    key: "scores",
    value: function scores() {
      return new MatchesScoresEndpoint(this);
    }
  }, {
    key: "stats",
    value: function stats(id) {
      return new MatchesStatsEndpoint(this, id);
    }
  }]);

  return MatchesEndpoint;
}(AbstractEndpoint);

var TeamsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(TeamsEndpoint, _AbstractEndpoint4);

  function TeamsEndpoint(client, id, team) {
    var _this3;

    _classCallCheck(this, TeamsEndpoint);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(TeamsEndpoint).call(this, client));
    _this3.team = team;
    _this3.id = id;
    _this3.url = "/v2/wvw/matches/stats/".concat(id, "/teams");
    return _this3;
  }

  _createClass(TeamsEndpoint, [{
    key: "top",
    value: function top(which) {
      return new TopStatsEndpoint(this, this.id, this.team, which);
    }
  }]);

  return TeamsEndpoint;
}(AbstractEndpoint);

var TopStatsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(TopStatsEndpoint, _AbstractEndpoint5);

  function TopStatsEndpoint(client, id, team, which) {
    var _this4;

    _classCallCheck(this, TopStatsEndpoint);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(TopStatsEndpoint).call(this, client));
    _this4.which = which;
    _this4.url = "/v2/wvw/matches/stats/".concat(id, "/teams/").concat(team, "/top/").concat(which);
    return _this4;
  }

  return TopStatsEndpoint;
}(AbstractEndpoint);

var MatchesOverviewEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(MatchesOverviewEndpoint, _AbstractEndpoint6);

  function MatchesOverviewEndpoint(client) {
    var _this5;

    _classCallCheck(this, MatchesOverviewEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(MatchesOverviewEndpoint).call(this, client));
    _this5.url = '/v2/wvw/matches/overview';
    _this5.isPaginated = true;
    _this5.isBulk = true;
    _this5.cacheTime = 30;
    return _this5;
  }

  _createClass(MatchesOverviewEndpoint, [{
    key: "world",
    value: function world(worldId) {
      return _get(_getPrototypeOf(MatchesOverviewEndpoint.prototype), "get", this).call(this, "?world=".concat(worldId), true);
    }
  }]);

  return MatchesOverviewEndpoint;
}(AbstractEndpoint);

var MatchesScoresEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint7) {
  "use strict";

  _inherits(MatchesScoresEndpoint, _AbstractEndpoint7);

  function MatchesScoresEndpoint(client) {
    var _this6;

    _classCallCheck(this, MatchesScoresEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(MatchesScoresEndpoint).call(this, client));
    _this6.url = '/v2/wvw/matches/scores';
    _this6.isPaginated = true;
    _this6.isBulk = true;
    _this6.cacheTime = 30;
    return _this6;
  }

  _createClass(MatchesScoresEndpoint, [{
    key: "world",
    value: function world(worldId) {
      return _get(_getPrototypeOf(MatchesScoresEndpoint.prototype), "get", this).call(this, "?world=".concat(worldId), true);
    }
  }]);

  return MatchesScoresEndpoint;
}(AbstractEndpoint);

var MatchesStatsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint8) {
  "use strict";

  _inherits(MatchesStatsEndpoint, _AbstractEndpoint8);

  function MatchesStatsEndpoint(client, id) {
    var _this7;

    _classCallCheck(this, MatchesStatsEndpoint);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(MatchesStatsEndpoint).call(this, client));
    _this7.id = id;
    _this7.url = '/v2/wvw/matches/stats';
    _this7.isPaginated = true;
    _this7.isBulk = true;
    _this7.cacheTime = 30;
    return _this7;
  }

  _createClass(MatchesStatsEndpoint, [{
    key: "world",
    value: function world(worldId) {
      return _get(_getPrototypeOf(MatchesStatsEndpoint.prototype), "get", this).call(this, "?world=".concat(worldId), true);
    }
  }, {
    key: "teams",
    value: function teams(team) {
      return new TeamsEndpoint(this, this.id, team);
    }
  }]);

  return MatchesStatsEndpoint;
}(AbstractEndpoint);

var ObjectivesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint9) {
  "use strict";

  _inherits(ObjectivesEndpoint, _AbstractEndpoint9);

  function ObjectivesEndpoint(client) {
    var _this8;

    _classCallCheck(this, ObjectivesEndpoint);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ObjectivesEndpoint).call(this, client));
    _this8.url = '/v2/wvw/objectives';
    _this8.isPaginated = true;
    _this8.isBulk = true;
    _this8.isLocalized = true;
    _this8.cacheTime = 24 * 60 * 60;
    return _this8;
  }

  return ObjectivesEndpoint;
}(AbstractEndpoint);

var UpgradesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint10) {
  "use strict";

  _inherits(UpgradesEndpoint, _AbstractEndpoint10);

  function UpgradesEndpoint(client) {
    var _this9;

    _classCallCheck(this, UpgradesEndpoint);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(UpgradesEndpoint).call(this, client));
    _this9.url = '/v2/wvw/upgrades';
    _this9.isPaginated = true;
    _this9.isBulk = true;
    _this9.isLocalized = true;
    _this9.cacheTime = 24 * 60 * 60;
    return _this9;
  }

  return UpgradesEndpoint;
}(AbstractEndpoint);

var RanksEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint11) {
  "use strict";

  _inherits(RanksEndpoint, _AbstractEndpoint11);

  function RanksEndpoint(client) {
    var _this10;

    _classCallCheck(this, RanksEndpoint);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(RanksEndpoint).call(this, client));
    _this10.url = '/v2/wvw/ranks';
    _this10.isPaginated = true;
    _this10.isBulk = true;
    _this10.isLocalized = true;
    _this10.cacheTime = 24 * 60 * 60;
    return _this10;
  }

  return RanksEndpoint;
}(AbstractEndpoint);